/**
 * Height reserved by layout wrappers when the promo marquee banner is
 * visible. Lives in its own module so layout code can import the number
 * without dragging the banner component (a client module with a
 * /api/promo/banner fetch, supabase and i18n imports) into every chunk.
 */
export const PROMO_BANNER_HEIGHT_PX = 32;
